import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { fetchBreadLabelsAction } from 'reducks/bread/actions'
import { BreadLabel } from 'types/bread'

const fetchBreadLabels = (breadRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    breadRef
      .collection('bread_labels')
      .get()
      .then((snapshots) => {
        const breadLabels = snapshots.docs.map((snapshot) => snapshot.data() as BreadLabel)
        dispatch(fetchBreadLabelsAction(breadLabels))
      })
  }
}

export default fetchBreadLabels
